module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv",
    style: ({
      backgroundImage: 'url(' + _vm.bigBgImg + ')'
    })
  }, [_c('div', {
    staticClass: "bgDiv",
    style: ({
      backgroundImage: 'url(' + _vm.bgImg + ')'
    })
  }, [_c('div', {
    staticClass: "imgDiv"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.coupon.qrCodeUrl
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btnDiv"
  }, [_c('span', {
    on: {
      "click": _vm.shared
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipDiv"
  }, [_c('div', {
    staticClass: "rowDiv"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v("返利规则")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("每张优惠券被使用后即可获得5元的返利,详情咨询棉花IN客服")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowDiv"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v("使用方式")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("用户下单结算时,可选择该优惠券抵减订单中的金额")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowDiv"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v("使用次数")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("不限次")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowDiv"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v("品类限制")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("标准布纹底台历")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowDiv"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v("有效日期")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("永久可用")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77279a2c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardCoupons/deskDiaryDiscount.vue
// module id = 462
// module chunks = 1